module.exports = __webpack_public_path__ + "static/media/14_before.8394857b.jpg";